import { UefaTokensImage, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type HowToClaimAddonTokenProps = {
	closeModal: () => void;
	testID: string;
};

export const HowToClaimAddonToken = ({ closeModal, testID }: HowToClaimAddonTokenProps) => {
	const { $t } = useIntl();

	return (
		<GenericDrawer
			buttonText={$t('button.gotIt')}
			description={$t<JSX.Element>('partner.leagueTokens.howToCollectDescription')}
			image={UefaTokensImage}
			testID={testID}
			title={$t('partner.leagueTokens.howToCollectTitle')}
			onButtonPress={closeModal}
		/>
	);
};
